<template>
  <div class="d-flex justify-center">
    <div class="col-2">
      <v-skeleton-loader
        width="100%"
        max-width="220px"
        max-height="150px"
        type="image" />
    </div>
    <div class="col-3">
      <v-skeleton-loader
        width="100%"
        max-width="300px"
        class="mb-1"
        type="list-item" />
      <v-skeleton-loader
        width="100%"
        max-width="300px"
        class="mb-1"
        type="list-item-three-line" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'CollectionHeaderSkeleton',
};
</script>
